import { Grid } from "@mui/system";
import {
    DeviceSummary,
    useDisplayDevices,
} from "../models/use-display-devices";
import { DeviceCard } from "./device-card-factory";
import { VideoProvider } from "../../../entities/video/provider/video-context";

interface DeviceSummaryLayoutProps {
    date: Date;
    summaries: DeviceSummary[];
}

export const DeviceSummaryLayout = ({
    summaries,
    date,
}: DeviceSummaryLayoutProps) => {
    const displayDevices = useDisplayDevices(summaries, date);

    return (
        <Grid
            container
            spacing={2}
            justifyContent="space-evenly"
            alignItems="center"
        >
            {displayDevices.map((summary) => (
                <Grid size={3} key={summary.device.id}>
                    <VideoProvider
                        videoId={summary.videoId}
                        isLoading={summary.isLoading}
                        isError={summary.isError ?? false}
                    >
                        <DeviceCard {...summary} />
                    </VideoProvider>
                </Grid>
            ))}
        </Grid>
    );
};
